import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { GB, ES, FR, DE, PT } from 'country-flag-icons/react/3x2';

interface LanguageSelectorProps {
  isScrolled: boolean;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ isScrolled }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: 'English', flag: GB },
    { code: 'es', name: 'Español', flag: ES },
    { code: 'de', name: 'Deutsch', flag: DE },
    { code: 'fr', name: 'Français', flag: FR },
    { code: 'pt', name: 'Português', flag: PT }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];
  const CurrentFlag = currentLanguage.flag;

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-center w-10 h-10 rounded-full transition-all duration-300 ${
          isScrolled 
            ? 'bg-white text-indigo-600 hover:bg-indigo-50 border border-gray-200' 
            : 'bg-white/10 backdrop-blur text-white hover:bg-white/20 border border-white/20'
        }`}
        aria-label="Select Language"
      >
        <div className="w-5 h-3 overflow-hidden rounded-sm shadow-sm">
          <CurrentFlag />
        </div>
      </button>
      
      {isOpen && (
        <>
          <div 
            className="fixed inset-0 bg-transparent z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-50">
            <div className="py-2">
              {languages.map((lang) => {
                const Flag = lang.flag;
                return (
                  <button
                    key={lang.code}
                    onClick={() => {
                      i18n.changeLanguage(lang.code);
                      setIsOpen(false);
                    }}
                    className={`w-full text-left px-4 py-3 hover:bg-indigo-50 transition-colors flex items-center justify-between group ${
                      i18n.language === lang.code ? 'bg-indigo-50' : ''
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <div className="w-6 h-4 overflow-hidden rounded shadow-sm">
                        <Flag />
                      </div>
                      <span className={`font-medium ${
                        i18n.language === lang.code ? 'text-indigo-600' : 'text-gray-700'
                      }`}>
                        {lang.name}
                      </span>
                    </div>
                    {i18n.language === lang.code && (
                      <Check className="h-5 w-5 text-indigo-600" />
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
